<template>
  <div class="security">
    <div class="tip">{{ $t('security.tip') }}</div>
    <h2 class="g-title title">{{ $t('security.title') }}</h2>
    <div class="top g-container">
      <div class="top__item">
        <img src="../../assets/ibm.png" class="top__item__img" alt="">
        <h3 class="top__item__title g-font-mid">{{ $t('security.s11title') }}</h3>
        <div class="top__item__content">{{ $t('security.s11content') }}</div>
      </div>
      <div class="top__item">
        <img src="../../assets/security.png" class="top__item__img" alt="">
        <h3 class="top__item__title g-font-mid">{{ $t('security.s12title') }}</h3>
        <div class="top__item__content">{{ $t('security.s12content') }}</div>
      </div>
      <div class="top__item">
        <img src="../../assets/encryption.png" class="top__item__img" alt="">
        <h3 class="top__item__title g-font-mid">{{ $t('security.s13title') }}</h3>
        <div class="top__item__content">{{ $t('security.s13content') }}</div>
      </div>
    </div>
    <div class="wrapper right">
      <div class="row right g-container">
        <div class="info">
          <div class="info__tip">{{ $t('security.s21tip') }}</div>
          <div class="info__title g-font-mid">{{ $t('security.s21title') }}</div>
          <div class="info__content">
            <div>{{ $t('security.s21content1') }}</div>
            <div>{{ $t('security.s21content2') }}</div>
            <div>{{ $t('security.s21content3') }}</div>
          </div>
          <a class="g-link-clear info__link" href="https://customer.railone.io/#/register">
            {{ $t('security.login') }}
          </a>
        </div>
        <div class="info--img__wrapper">
          <img class="info--img" src="../../assets/security1.png" alt="">
        </div>
      </div>
    </div>
    <div class="wrapper left">
      <div class="row left g-container">
        <div class="info--img__wrapper">
          <img class="info--img" src="../../assets/security2.png" alt="">
        </div>
        <div class="info">
          <div class="info__tip">{{ $t('security.s22tip') }}</div>
          <div class="info__title g-font-mid">{{ $t('security.s22title') }}</div>
          <div class="info__content">
            <div>{{ $t('security.s22content1') }}</div>
            <div>{{ $t('security.s22content2') }}</div>
            <div>{{ $t('security.s22content3') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper right">
      <div class="row right g-container">
        <div class="info">
          <div class="info__title g-font-mid">{{ $t('security.s23title') }}</div>
          <div class="info__content">
            <div>{{ $t('security.s23content1') }}</div>
            <div>{{ $t('security.s23content2') }}</div>
          </div>
          <a class="g-link-clear info__link" href="https://github.com/railone-io/railone-docs">{{
            $t('security.apiDocs') }} ></a>
        </div>
        <div class="info--img__wrapper">
          <img class="info--img" src="../../assets/security3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Security',
};
</script>

<style lang="scss" scoped>
  .security {
    padding-top: 120px;
    text-align: center;
    background: rgba(224, 235, 242, .3);
  }

  .tip {
    font-size: 16px;
    line-height: 28px;
    color: var(--color-content);
  }

  .title {
    margin-top: 10px;
  }

  .top {
    margin-top: 100px;
    padding-bottom: 200px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 30px;
    justify-items: center;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
      grid-row-gap: 40px;
    }
  }

  .top__item {
    min-height: 500px;
    overflow: hidden;
    text-align: center;
    box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    background: #FFF;

    @media (max-width: 960px) {
      max-width: 400px;
    }
  }

  .top__item__img {
    margin-top: 80px;
    height: 80px;
  }

  .top__item__title {
    margin-top: 30px;
    font-size: 24px;
    line-height: 28px;
    color: var(--color-theme);
  }

  .top__item__content {
    padding: 0 40px;
    margin-top: 30px;
    font-size: 16px;
    line-height: 28px;
    color: var(--color-content);
  }

  .info {
    /*margin: 117px auto 0;*/
    max-width: 500px;
    text-align: left;
  }

  .info__link {
    display: inline-block;
    margin-top: 40px;
    font-size: 18px;
    line-height: 22px;
    color: rgba(94, 207, 197, 1);
    text-decoration: underline;
  }

  .info__tip {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 28px;
    color: var(--color-content);
  }

  .info__title {
    font-size: 40px;
    line-height: 50px;
  }

  .info__content {
    margin-top: 30px;
    color: var(--color-content);
    font-size: 18px;
    line-height: 28px;
  }

  .info--img__wrapper {
    /*background-image: url("../../assets/security-bg.png");*/
    /*background-repeat: no-repeat;*/
    /*background-size: auto 100%;*/
    /*background-position: top right;*/
    /*padding-bottom: 200px;*/
    position: relative;
  }

  .info--img {
    max-width: 100%;
  }

  .info--img__bg {
    position: absolute;
    left: 0;
    z-index: 0;
  }

  .wrapper {
    &.right {
      padding-bottom: 200px;
      background-image: url("../../assets/security-bg.svg");
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: right top;
      @media (max-width: 960px) {
        background: none;
      }
    }

    &.left {
      padding-bottom: 200px;
      background-image: url("../../assets/security-bg-left.svg");
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: left top;
      @media (max-width: 960px) {
        background: none;
      }
    }
  }

  .row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    align-items: center;

    & > *:nth-child(2) {
      justify-self: right;
    }

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
      justify-items: center;
      grid-row-gap: 100px;
      & > *:nth-child(2) {
        justify-self: center;
      }

      &.right {
        & > *:nth-child(1) {
          grid-row: 2;
        }
        & > *:nth-child(2) {
          grid-row: 1;
        }
      }
    }
  }
</style>
